import { useParams } from 'react-router-dom';
import FormContainer from '../FormContainer';
import EditFarm from './EditFarm';

const SuperadminFarmSettings = () => {
  const { farmId } = useParams();

  return (
    <FormContainer className="mt-3">
      <h2>Project Settings</h2>
      <EditFarm farmId={farmId} showBreadcrumbs />
    </FormContainer>
  );
};

export default SuperadminFarmSettings;
